import React from "react";
import { ReactComponent as ArmchairSvg } from "../svg/armchair.svg";

export default function ArmchairIcon({ size = 64, color = "#32363F", ...props }) {
  return <ArmchairSvg width={size} height={size} style={{ color }} {...props} />;
}
